const MODE = JSON.parse(import.meta.env.VITE_ETC);

/**
 * The plain HTML template hosted on the CDN: one page per Skapi feature, each
 * running against the project named in its ?pid= parameter. The template's
 * service.js keeps that id in sessionStorage and puts it on every link, form
 * action and redirect, so a visitor who is bounced through login.html and
 * back stays on the project the link started from, even with several project
 * pages open at once.
 */
export const TEMPLATE_BASE = MODE === null ? "https://cdn.broadwayinc.com/temp/v4/" : "https://cdn.broadwayinc.com/temp/v4dev/";

/** Every page of the template as one ZIP file, to study or build on. */
export const TEMPLATE_ZIP = TEMPLATE_BASE + "skapi-templates.zip";

export interface TemplatePage {
    /** Short name of the template. */
    key: string;
    /** File name on the CDN. */
    page: string;
    /** Material Symbols name; must be in the icon_names list in index.html. */
    icon: string;
    label: string;
    hint: string;
}

export const TEMPLATES: TemplatePage[] = [
    {
        key: "account",
        page: "account.html",
        icon: "person",
        label: "User Account",
        hint: "Sign up, log in, verify an email address, reset or change a password, update a profile, remove and recover an account.",
    },
    {
        key: "newsletter",
        page: "newsletter.html",
        icon: "newspaper",
        label: "Newsletter",
        hint: "Let visitors subscribe to your newsletter with their email address.",
    },
    {
        key: "inquiry",
        page: "inquiry.html",
        icon: "forward_to_inbox",
        label: "Send Inquiry",
        hint: "A contact form that sends a message to you, the project owner.",
    },
    {
        key: "database",
        page: "database.html",
        icon: "database",
        label: "Database",
        hint: "A photo gallery: upload posts with files, like, comment, subscribe to other users and query posts in different ways.",
    },
    {
        key: "realtime",
        page: "realtime.html",
        icon: "forum",
        label: "Realtime Chat",
        hint: "Group chat and private messages over a WebSocket connection.",
    },
    {
        key: "webrtc",
        page: "webrtc.html",
        icon: "videocam",
        label: "RTC Video Chat",
        hint: "Video calls, screen sharing, text chat and file transfer between two users with WebRTC.",
    },
    {
        key: "drawing",
        page: "drawing.html",
        icon: "draw",
        label: "Shared Drawing",
        hint: "Two users draw on one canvas; every stroke travels over a WebRTC data channel.",
    },
];

/** The address of one template page for one project: the page plus ?pid=. */
export function templateUrl(page: string, projectId: string): string {
    const url = new URL(page, TEMPLATE_BASE);
    url.searchParams.set("pid", projectId);
    return url.href;
}
